"use client";

import { useState } from "react";

import { hasArrayElements, isPDF } from "@/apiUtils/commonUtils";
import ArrowLeftIcon from "@/assets/icons/arrow-left.svg?react";
import ArrowRightIcon from "@/assets/icons/arrow-right.svg?react";
import { PrescriptionData, TranslationData } from "@/common/lib/types";
import LazyImage from "@/components/lazyImage/LazyImage";
import { Carousel } from "@/components/ui/carousel/Carousel";
import Modal from "@/components/ui/modal_new/Modal";

interface IProps {
  open: boolean;
  onClose: () => void;
  translations: TranslationData;
  documents: PrescriptionData["images"];
}

const ViewPrescriptionDocuments = ({ onClose, open, documents, translations }: IProps) => {
  const [slideInView, setSlideInView] = useState(0);

  return (
    <Modal isOpen={open} onClose={onClose}>
      <div className="mt-4 flex w-full max-w-[25rem] flex-col items-center justify-center px-8 py-2">
        <Carousel
          parentClasses="w-full"
          autoPlay={{ playOnInit: false, active: false }}
          onScrollSnap={(index) => setSlideInView(index)}
          {...(documents &&
            documents.length > 1 && {
              controls: {
                distance: "-35px",
                left: {
                  top: "50%",
                  content: (
                    <button
                      disabled={slideInView === 0}
                      className="bg-[#66666617] p-2 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                      <ArrowLeftIcon />
                    </button>
                  ),
                },
                right: {
                  top: "50%",
                  content: (
                    <button
                      disabled={slideInView === 1}
                      className="bg-[#66666617] p-2 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                      <ArrowRightIcon />
                    </button>
                  ),
                },
              },
            })}
          slides={
            documents && hasArrayElements(documents)
              ? documents.map((doc) => ({
                  slideClasses: "basis-full",
                  content: (
                    <div className="mb-6 w-full">
                      {isPDF(doc.url) ? (
                        <embed src={doc.url} width="100%" height="500" />
                      ) : (
                        <LazyImage
                          width={349}
                          height={255}
                          src={doc.url}
                          alt={doc.name}
                          className="h-full w-full"
                        />
                      )}
                    </div>
                  ),
                }))
              : []
          }
        />
        <p className="text-sm">
          {translations?.lensConfigurator?.lens_config_prescription_pagination_label
            ?.replace("{{total}}", `${documents?.length}`)
            ?.replace("{{page}}", `${slideInView + 1}`)}
        </p>
      </div>
    </Modal>
  );
};

export default ViewPrescriptionDocuments;
